import { render, staticRenderFns } from "./smsGatewaysTable.vue?vue&type=template&id=70cc231a&"
import script from "./smsGatewaysTable.vue?vue&type=script&lang=js&"
export * from "./smsGatewaysTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports